import { Component, Object3D } from '@wonderlandengine/api';
import { property } from '@wonderlandengine/api/decorators.js';
import { TriggerTarget } from '../interactions/triggerTarget.js';
import { GameManager, ObjectiveType } from '../core/game-manager.js';

export class CompleteObjective extends Component {
    static TypeName = 'complete-objective';

    private _triggerTarget?: TriggerTarget | null;

    @property.enum(
        Object.keys(ObjectiveType).filter((e) => isNaN(Number(e))),
        ObjectiveType.None
    )
    objective: ObjectiveType = ObjectiveType.None;

    start(): void {
        this._triggerTarget = this.object.getComponent(TriggerTarget)!;
    }

    onActivate(): void {
        this._triggerTarget?.onExecute.add(this._onExecute);
    }

    onDeactivate(): void {
        this._triggerTarget?.onExecute.remove(this._onExecute);
    }

    private _onExecute = () => {
        GameManager.instance.completeObjective(this.objective);
    };
}
